import { useCallback } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useSystemSettings } from './useSystemSettings';

interface MaintenanceModeHook {
  isMaintenanceMode: boolean;
  isLoading: boolean;
  toggleMaintenanceMode: (value: boolean) => Promise<void>;
}

export function useMaintenanceMode(): MaintenanceModeHook {
  const { data, isLoading } = useSystemSettings();

  const isMaintenanceMode = data?.maintenance_mode?.enabled ?? false;

  const toggleMaintenanceMode = useCallback(async (value: boolean) => {
    const { error } = await supabase
      .from('system_settings')
      .update({ 
        setting_value: { enabled: value }, 
        updated_at: new Date().toISOString() 
      })
      .eq('setting_key', 'maintenance_mode');

    if (error) {
      console.error('Error updating maintenance mode:', error);
      throw error;
    }
  }, []);

  return { isMaintenanceMode, isLoading, toggleMaintenanceMode };
}
